import About from "../../views/About/About";
import Header from "../../views/Header/Header";
import Contact from "../../views/Contact/Contact";
import Map from "../../views/Map/Map";
import RequestAQuote from "../../views/RequestAQuote/RequestAQuote";
import WhyNexus from "../../views/WhyNexus/WhyNexus";
import "./Root.css";
import Nav from "../../components/organism/Nav";

function App() {
  return (
    <div className="App">
      <Nav />
      <Header />
      <About />
      <RequestAQuote />
      <WhyNexus />
      <Contact />

      <Map />
    </div>
  );
}

export default App;
